import { LOCATION_CHANGE } from '@qadra/frontend-common/redux';
import { FORGOT, PASSWORD_RESET } from '../actions';

export const initialState = {
  error: null,
  emailSent: false,
  passSent: false
};

export const forgot = (state = initialState, action) => {
  switch (action.type) {
    case LOCATION_CHANGE: {
      state.error = null;
      state.emailSent = false;
      state.passSent = false;
      return state;
    }
    case FORGOT._ERROR: {
      state.error = action.error;
      state.emailSent = false;
      return state;
    }
    case FORGOT._SUCCESS: {
      state.error = null;
      state.emailSent = action.emailSent;
      return state;
    }
    case PASSWORD_RESET._ERROR: {
      state.error = action.error;
      state.passSent = false;
      return state;
    }
    case PASSWORD_RESET._SUCCESS: {
      state.error = null;
      state.passSent = action.passSent;
      return state;
    }
    default:
      return state;
  }
};
